import request from "@/utils/request";

// export function collectWAV(data) {
//   return request({
//     url: "/wav/api",
//     method: "put",
//     data
//   });
// }

export function getCollectWAV(checkMedicalhistoryId) {
  return request({
    url: "/wav/api",
    method: "get",
    params: { ifCollection: true, checkMedicalhistoryId }
  });
}

/*
* 车前急救 现场描述的保存
* */
export function saveLiveDesc(data) {
  return request({
    url: "/srs/medicalhistory/live/desc",
    method: "post",
    data
  });
}

/*
* 保存急救事件的急救信息
* */
export function saveLiveInformation(data) {
  return request({
    url: "/srs/medicalhistory/infomation",
    method: "post",
    data
  });
}

/*
* 获取急救事件的急救信息
* */
export function getLiveInformation(id) {
  // console.log(id);
  return request({
    url: "/srs/medicalhistory/infomation",
    method: "get",
    params: { id }
  });
}

/*
* 获取腾讯联合身份临时访问凭证
* */
export function getTencentAuthentication() {
  return request({
    url: "/new/version/tencent/authentication/data",
    method: "get",
  });
}

/*
* 使用TRTC录音获取
* */
export function getTencentRecords(id) {
  return request({
    url: "/new/version/wav/files",
    method: "get",
    params: { id }
  });
}
